import { render, staticRenderFns } from "./userDetail.vue?vue&type=template&id=1af0754d&scoped=true"
import script from "./userDetail.vue?vue&type=script&lang=js"
export * from "./userDetail.vue?vue&type=script&lang=js"
import style0 from "./userDetail.vue?vue&type=style&index=0&id=1af0754d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af0754d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/test-cdp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1af0754d')) {
      api.createRecord('1af0754d', component.options)
    } else {
      api.reload('1af0754d', component.options)
    }
    module.hot.accept("./userDetail.vue?vue&type=template&id=1af0754d&scoped=true", function () {
      api.rerender('1af0754d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/userCenter/userList/userDetail.vue"
export default component.exports